export class CoursStream {
  places$!: any;
  courseNames$!: any;
  filteredCourses$!: any;
}
